import React from 'react';

const TransparentContainer = ({ children, width = '20%', padding = '10px' }) => {
  return (
    <div
      className="bg-white d-flex justify-content-center align-items-center"
      style={{
        minWidth: '260px', // Минимальная ширина для корректного переноса
        width: width,
        height: 'auto',
        padding: padding,
        borderRadius: '0',
        position: 'relative',
        flexWrap: 'wrap', // Чтобы контейнеры переносились только если не влезают
      }}
    >
      <div className="text-center">
        {children}
      </div>
    </div>
  );
};

export default TransparentContainer;
